<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Header from './view/Header';
export default {
  // components: {
  //   Header
  // }
  created() {
    // 当vuex中没有用户登陆数据时，在localStorage.getItem("supUser");取
    if(!this.$store.state.supUser.id){
           console.log("------执行-------")
      var supUser=JSON.parse(localStorage.getItem("supUser"))
       this.$store.commit('updataRole',supUser) //将用户数据存到vuex
       console.log(this.$store.state.supUser)
    }
  },
};
</script>

<style></style>
